import { Grid, InputAdornment, Switch, Typography } from "@mui/material";
import React, { useState } from "react";

import { TextFieldWithLabel } from "../components/TextFieldWithLabel/TextFieldWithLabel";
import { displayPriceFormat } from "./displayPriceFormat";
import { isNotNull } from "./isNotNull";
import {
  CustomNumberField,
  CustomTextField,
} from "../components/formsComponents";
import { formatCurrencyInIndian, formatWithCommas } from "./formatWithCommas";

export interface IDiscountAndTaxFieldProps {
  disabledAll?: boolean;
  percentageTitle: string;
  percentage: string | number | null;
  onPercentageChange: (data: number) => void;
  percentageValueTitle: string;
  percentageValue: string | number | null;
  onPercentageValueChange: (data: number) => void;
}

export const DiscountAndTaxField: React.FC<IDiscountAndTaxFieldProps> = ({
  disabledAll,
  percentageTitle,
  percentage,
  onPercentageChange,
  percentageValueTitle,
  percentageValue,
  onPercentageValueChange,
}) => {
  const [showAmountType, setShowAmountType] = useState(() => {
    return Number(percentage || 0) === 0 && Number(percentageValue || 0) > 0;
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <CustomNumberField
          heading={percentageTitle}
          fullWidth
          value={percentage as string}
          onChange={(evt) => {
            setShowAmountType(false);
            onPercentageChange(Number(evt.target.value));
            if (isNotNull(evt.target.value) === 0) {
              onPercentageValueChange(Number(evt.target.value));
            }
          }}
          disabled={showAmountType || disabledAll}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
        sx={{ display: "flex", alignItems: "center", mt: { xs: 1, md: 5 } }}
      >
        <Typography  sx={{ color: "GrayText" }} fontWeight={600}>
          %
        </Typography>
        <Switch
          checked={showAmountType}
          onChange={(e, checked) => {
            if (checked) {
              onPercentageChange(0);
            } else {
              onPercentageValueChange(0);
            }
            setShowAmountType(checked);
          }}
          disabled={disabledAll}
        />
        <Typography  sx={{ color: "GrayText" }} fontWeight={600}>
          Amount
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        {showAmountType ? (
          <CustomTextField
            title={percentageValueTitle}
            fullWidth
            type="string"
            sx={{ mt: { xs: 1, md: 5 } }}
            disabled={!showAmountType}
            value={formatCurrencyInIndian(percentageValue as string)}
            onChange={(evt) => {
              setShowAmountType(true);
              const rawValue = evt.target.value.replace(/[^0-9]/g, "");
              const numericValue =
                rawValue === "" ? "" : String(Number(rawValue));
              onPercentageValueChange(Number(numericValue));
            }}
          />
        ) : (
          <CustomTextField
            title={percentageValueTitle}
            disabled
            sx={{ mt: { xs: 1, md: 5 } }}
            type="string"
            fullWidth
            value={formatCurrencyInIndian(percentageValue)}
          />
        )}
      </Grid>
    </Grid>
  );
};
